import { css } from '@emotion/react';
import { SectionTitle } from '@/components/general/SectionTitle';
import { TaskCard } from '@/components/top-page/TaskCard';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type TaskSituationSectionProps = {
  className?: string;
};

export const TaskSituationSection: React.FC<TaskSituationSectionProps> = ({
  className,
}) => {
  return (
    <section
      css={css`
        padding: 64px 10px 72px;

        @media ${getScreen('pc')} {
          padding: 104px 0 128px;
        }
      `}
      className={className}
    >
      <SectionTitle
        css={css`
          position: relative;
          z-index: 1;
        `}
        en="TASK SITUATION"
        subText={
          <></>
        }
      >
        <div
          css={css`
            width: 219px;
            height: 219px;
            background: #def6f5;
            opacity: 0.49;
            filter: blur(36px);
            border-radius: 9999px;
            position: absolute;
            top: -17px;
            left: 50%;
            transform: translateX(-50%);
            z-index: -1;
            pointer-events: none;

            @media ${getScreen('pc')} {
              width: 349px;
              height: 349px;
              top: -58px;
            }
          `}
        ></div>
        <strong
          css={css`
            display: block;
            margin-bottom: 10px;
            color: #00b3a7;
            font-size: 14px;
            
            @media ${getScreen('pc')} {
              font-size: 22px;
            }
            
          `}
        >
          猫の手も借りたいほど多忙な経営者の皆さま
        </strong>
        <strong>IPO・M&Aの準備</strong>で<br
          css={css`
            @media ${getScreen('pc')} {
              display: none;
            }
          `}
        />このような<strong>課題</strong>を抱えていませんか？
      </SectionTitle>
      <div
        css={css`
          margin: 142px 0 68px;
          display: flex;
          flex-direction: column;
          gap: 40px;
          padding: 35px 20px 53px;
          background: #def6f5;
          border-radius: 43px;
          position: relative;
          z-index: 1;

          @media ${getScreen('pc')} {
            padding: 25px 60px;
            max-width: 1126px;
            margin: 195px auto 94px;
            border-radius: 62px;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 35px;
          }

          &::before,
          &::after {
            content: '';
            display: block;
            z-index: -1;
            position: absolute;
            height: 62px;
            border-radius: 50%;
            background: #def6f5;
            top: -19px;
            left: 20px;
            right: 20px;

            @media ${getScreen('pc')} {
              top: -25px;
              left: 40px;
              right: 40px;
            }
          }

          &::after {
            top: initial;
            bottom: -19px;

            @media ${getScreen('pc')} {
              bottom: -25px;
            }
          }
        `}
      >
        <div
          css={css`
            position: absolute;
            top: -98px;
            left: 50%;
            transform: translateX(-50%);

            @media ${getScreen('pc')} {
              display: none;
            }
          `}
        >
          <img
            src={withPrefix('/images/task-situation.svg')}
            width="300"
            height="116"
            alt=""
          />
        </div>
        <div
          css={css`
            position: absolute;
            top: -147px;
            left: 50%;
            transform: translateX(-50%);

            @media ${getScreen('pc', '未満')} {
              display: none;
            }
          `}
        >
          <img
            src={withPrefix('/images/task-situation-pc.svg')}
            width="587"
            height="160"
            alt=""
          />
        </div>
        <TaskCard head="IPO" variant="IPO">
          <li>
            何から準備を始めればいいかわからない
          </li>
          <li>
            上場スケジュールの遅延が心配
          </li>
          <li>
            社内リソースのみではIPOの準備がすすまない
          </li>
        </TaskCard>
        <TaskCard head="M&A" variant="M&A">
          <li>
            IPOも視野に入れつつM&Aの準備も進めたい
          </li>
          <li>
            企業価値を上げるための内部統制を知りたい
          </li>
          <li>
            買い手が求める評価基準がわからない
          </li>
        </TaskCard>
        <TaskCard head="内部統制構築" variant="内部統制構築">
          <li>
            自社に合わせたペースで内部管理体制を構築したい
          </li>
          <li>
            いつまでにどの程度の統制が必要かわからない
          </li>
          <li>
            作業量が多く、本来の業務を圧迫している
          </li>
        </TaskCard>
        <TaskCard head="経営管理" variant="経営管理">
          <li>
            今後の事業計画や資本政策に不安がある
          </li>
          <li>
            CEOが事業や経営以外に時間を取られている
          </li>
          <li>
            どこに相談すれば疑問を解決できるかわからない
          </li>
        </TaskCard>
      </div>
      
    </section>
  );
};
